<div class="complaint" *ngIf="!showSyncedInfo">
    <form [formGroup]="complaintFormValidatedFields" class="complaint-form" (submit)="save()">
        <div class="complaint-form__title">{{ !isB2bComplaintForm ? ('COMPLAINT|Zgłoszenie serwisowe do punktu sprzedaży' | translate) : ('COMPLAINT|Zgłoszenie serwisowe' | translate) }}</div>
        <div class="form-steps">
            <ol class="form-steps-list">
                <li *ngFor="let step of formSteps; let i = index" [id]="'step-' + i" [class.active]="isB2bComplaintForm ? currentStep === i + 2 : currentStep === i + 1">
                    <span class="step-number">{{ i + 1 }}. </span> <span>{{ step }}</span>
                </li>
            </ol>
        </div>
        <div class="complaint-form__step">
            <ng-container *ngIf="currentStep === 1 && !isB2bComplaintForm">
                <div class="complaint-form__step-title">
                </div>
                <div class="complaint-form__input">
                    <icc-input
                        type="text"
                        [value]="complaint.clientName"
                        [size]="'medium'"
                        [name]="'clientName'"
                        [prefixIcon]="'person'"
                        (valueChange)="complaint.clientName = $event"
                        [required]="true"
                        [placeholder]="'PERSON|Imię i Nazwisko' | translate"
                        [label]="'PERSON|Imię i Nazwisko' | translate"
                        [maxLength]="255"
                    ></icc-input>
                </div>
                <div class="complaint-form__input">
                    <icc-input
                        formControlName="clientEmail"
                        type="email"
                        [size]="'medium'"
                        [name]="'clientEmail'"
                        [prefixIcon]="'email'"
                        [required]="true"
                        (valueChange)="complaint.clientEmail = $event"
                        [placeholder]="'CONTACT|Adres e-mail' | translate"
                        [label]="'CONTACT|Adres e-mail' | translate"
                        [emailValidation]="true"
                    ></icc-input>
                </div>
                <div class="complaint-form__input">
                    <icc-input
                        formControlName="clientPhoneNumber"
                        type="text"
                        [size]="'medium'"
                        [name]="'clientPhoneNumber'"
                        [prefixIcon]="'phone'"
                        [required]="true"
                        (valueChange)="complaint.clientPhoneNumber = $event"
                        [placeholder]="'CONTACT|Nr telefonu' | translate"
                        [label]="'CONTACT|Nr telefonu' | translate"
                        [phoneNumberValidation]="true"
                        [phoneNumberErrorMessage]="'CONTACT|Niepoprawny format numeru telefonu: \'+\' - dozwolony tylko jako pierwszy opcjonalny znak, następnie dozwolone znaki ze zbioru: 0123456789\(\),;#-' | translate"
                    ></icc-input>
                </div>
                <div class="complaint-form__radio" style="margin-top: 20px;">
                    <icc-radio
                        name="address-mode"
                        [value]="'exact'"
                        [checked]="addressMode === 'exact'"
                        [(ngModel)]="addressMode"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onAddressModeChange($event)"
                    >
                        {{ 'COMPLAINT|Podaję dokładny adres instalacji' | translate }}
                    </icc-radio>
                    <icc-radio
                        name="address-mode"
                        [value]="'map'"
                        [checked]="addressMode === 'map'"
                        [(ngModel)]="addressMode"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onAddressModeChange($event)"
                    >
                        {{ 'COMPLAINT|Brak adresu – zaznaczę lokalizację na mapie' | translate }}
                    </icc-radio>
                </div>
                <ng-container *ngIf="addressMode === 'exact'">
                    <div class="complaint-form__input">
                        <icc-input
                            formControlName="addressLine1"
                            type="text"
                            [value]="addressLine1"
                            [size]="'medium'"
                            [name]="'addressLine1'"
                            [prefixIcon]="'location'"
                            [required]="true"
                            (valueChange)="onAddressFieldChange('addressLine1', $event)"
                            (blurChange)="onInstallationAddressChange()"
                            [placeholder]="'COMPLAINT|Ulica' | translate"
                            [label]="'COMPLAINT|Ulica' | translate"
                            [maxLength]="100"
                        ></icc-input>
                    </div>
                    <div class="complaint-form__input complaint-form__input--half">
                        <icc-input
                            formControlName="postalCode"
                            type="text"
                            [value]="postalCode"
                            [size]="'medium'"
                            [name]="'postalCode'"
                            [prefixIcon]="'location'"
                            [required]="true"
                            (valueChange)="onAddressFieldChange('postalCode', $event)"
                            (blurChange)="onInstallationAddressChange()"
                            [placeholder]="'COMPLAINT|Kod pocztowy' | translate"
                            [label]="'COMPLAINT|Kod pocztowy' | translate"
                            [maxLength]="10"
                        ></icc-input>
                    </div>
                    <div class="complaint-form__input complaint-form__input--half">
                        <icc-input
                            formControlName="city"
                            type="text"
                            [value]="city"
                            [size]="'medium'"
                            [name]="'city'"
                            [prefixIcon]="'location'"
                            [required]="true"
                            (valueChange)="onAddressFieldChange('city', $event)"
                            (blurChange)="onInstallationAddressChange()"
                            [placeholder]="'COMPLAINT|Miejscowość' | translate"
                            [label]="'COMPLAINT|Miejscowość' | translate"
                            [maxLength]="100"
                        ></icc-input>
                    </div>
                </ng-container>
                <ng-container *ngIf="addressMode === 'map'">
                    <div class="complaint-form__input">
                        <icc-input
                            type="text"
                            [value]="complaint.locationDescription || ''"
                            [size]="'medium'"
                            [name]="'locationDescription'"
                            [prefixIcon]="'location'"
                            [required]="false"
                            [supportText]="'COMPLAINT|To pole jest informacyjne i nie bierze udziału w geolokalizacji' | translate"
                            (valueChange)="complaint.locationDescription = $event?.toString()"
                            [placeholder]="'COMPLAINT|Opis lokalizacji' | translate"
                            [label]="'COMPLAINT|Opis lokalizacji' | translate"
                            [maxLength]="255"
                        ></icc-input>
                    </div>
                    <div class="complaint-form__input complaint-form__input--half">
                        <icc-input
                            formControlName="postalCode"
                            type="text"
                            [value]="postalCode"
                            [size]="'medium'"
                            [name]="'postalCode'"
                            [prefixIcon]="'location'"
                            [required]="true"
                            (valueChange)="onAddressFieldChange('postalCode', $event)"
                            (blurChange)="onInstallationAddressChange()"
                            [placeholder]="'COMPLAINT|Kod pocztowy' | translate"
                            [label]="'COMPLAINT|Kod pocztowy' | translate"
                            [maxLength]="10"
                        ></icc-input>
                    </div>
                    <div class="complaint-form__input complaint-form__input--half">
                        <icc-input
                            formControlName="city"
                            type="text"
                            [value]="city"
                            [size]="'medium'"
                            [name]="'city'"
                            [prefixIcon]="'location'"
                            [required]="true"
                            (valueChange)="onAddressFieldChange('city', $event)"
                            (blurChange)="onInstallationAddressChange()"
                            [placeholder]="'COMPLAINT|Miejscowość' | translate"
                            [label]="'COMPLAINT|Miejscowość' | translate"
                            [maxLength]="100"
                        ></icc-input>
                    </div>
                </ng-container>

                <div *ngIf="apiLoaded && installationAddress && !mapLoadError" class="complaint-form__input">
                    <google-map
                        [zoom]="mapZoom"
                        [center]="installationAddress!"
                    >
                        <map-marker [position]="installationAddress!" [options]="markerOptions" (mapDragend)="onMarkerDragEnd($event)"></map-marker>
                    </google-map>
                </div>

                <div *ngIf="mapLoadError" class="complaint-form__input">
                    <div class="map-error-message" style="padding: 20px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; margin: 10px 0;">
                        <p>{{ 'COMPLAINT|Brak połączenia z serwisem Map. Proszę spróbować ponownie lub opisać lokalizację słownie w polu "Opis lokalizacji"' | translate }}</p>
                        <button type="button" class="btn btn-primary" (click)="reloadMap()">
                            {{ 'COMPLAINT|Odśwież mapę' | translate }}
                        </button>
                    </div>
                </div>
                </ng-container>

                <ng-container *ngIf="currentStep === 2">
                     <div class="complaint-form__step-title">
                </div>
                <div class="complaint-form__radio" *ngIf="Object.keys(availableDocumentTypesDict).length > 1">
                    <ng-container *ngFor="let documentType of availableDocumentTypesDict | keyvalue">
                            <icc-radio
                                name="document-type"
                                [value]="number(documentType.key)"
                                [checked]="checkDocumentType(documentType.key)"
                                [(ngModel)]="complaint.documentTypeId"
                                [ngModelOptions]="{standalone: true}"
                                >
                                {{ documentType.value | translate }}
                            </icc-radio>
                    </ng-container>
                </div>
                <div class="complaint-form__input">
                    <icc-input
                        type="date"
                        [value]="complaint.purchaseDate"
                        [size]="'medium'"
                        [name]="'purchaseDate'"
                        [datePickerSide]="'left'"
                        [required]="complaint.documentTypeId === documentTypes.complaint"
                        (valueChange)="complaint.purchaseDate = $event"
                        [placeholder]="'COMPLAINT|Data zakupu' | translate"
                        [label]="'COMPLAINT|Data zakupu' | translate"
                        [dateErrorMessage]="'COMPLAINT|Wprowadź datę w formacie: dd.mm.rrrr' | translate"
                        [max]="today"
                    ></icc-input>
                    <icc-icon name="info" (click)="showPurchaseDateInfo()"></icc-icon>
                </div>

                <ng-container *ngIf="!isB2bComplaintForm">
                    <div class="complaint-form__select" style="margin: 0">
                        <ng-select [items]="authorizedRetailers"
                            [editableSearchTerm]="true"
                            bindLabel="companyName"
                            bindValue="companyId"
                            autocomplete="off"
                            [(ngModel)]="authorizedRetailerCompanyId"
                            [ngModelOptions]="{standalone: true}"
                            [virtualScroll]="true"
                            [searchable]="true"
                            [notFoundText]="'COMPLAINT|Brak wyników' | translate"
                            [placeholder]="'COMPLAINT|Wybierz / wyszukaj punkt sprzedaży' | translate"
                            [minTermLength]="5"
                            [searchFn]="searchAuthorizedRetailer"
                            [clearOnBackspace]="false"
                            (search)="onAuthorizedRetailerSearch($event)"
                            (clear)="onAuthorizedRetailerSearch($event)"
                            (change)="onAuthorizedRetailerChange($event)"
                            style="flex: 1;"
                        >
                            <ng-template ng-option-tmp let-item="item">
                                <span>{{ item.companyName }}</span>
                                <small *ngIf="item.postalCode || item.city" class="ng-option-address">{{ item.postalCode }} {{ item.city }}</small>
                            </ng-template>
                        </ng-select>
                        <icc-icon></icc-icon>
                    </div>
                    <small>{{ 'COMPLAINT|Podaj nazwę, NIP lub adres punktu sprzedaży, aby wyszukać' | translate }}</small>

                    <div *ngIf="noSalesPoint" class="complaint-form__input" style="margin-top: 16px;">
                        <icc-input
                            type="text"
                            [value]="noSalesPoint ? complaint.authorizedRetailer.referenceName : ''"
                            [size]="'medium'"
                            [name]="'referenceName'"
                            (valueChange)="complaint.authorizedRetailer.referenceName = $event"
                            [prefixIcon]="'info'"
                            [supportText]="'COMPLAINT|Brak wybrania punktu sprzedaży może uniemożliwić przekazanie zgłoszenia do tego punktu. Jeśli zostanie podany nr seryjny produktu w danych usterki podejmiemy próbę identyfikacji zamówienia sprzedaży i przekazania zgłoszenia do właściwego podmiotu.' | translate"
                            [placeholder]="'COMPLAINT|Punkt sprzedaży - nazwa' | translate"
                            [label]="'COMPLAINT|Punkt sprzedaży - nazwa' | translate"
                        ></icc-input>
                        <icc-icon></icc-icon>
                    </div>
                    <div  *ngIf="noSalesPoint" class="complaint-form__input">
                        <icc-input
                            type="text"
                            [value]="noSalesPoint ? complaint.authorizedRetailer.address : ''"
                            [size]="'medium'"
                            [name]="'adres'"
                            (valueChange)="complaint.authorizedRetailer.address = $event"
                            [prefixIcon]="'location'"
                            [placeholder]="'COMPLAINT|Punkt sprzedaży - adres' | translate"
                            [label]="'COMPLAINT|Punkt sprzedaży - adres' | translate"
                        ></icc-input>
                        <icc-icon></icc-icon>
                    </div>
                    <div *ngIf="noSalesPoint" class="complaint-form__input">
                        <icc-input
                            type="text"
                            [value]="noSalesPoint ? complaint.authorizedRetailer.companyVatNr : ''"
                            [size]="'medium'"
                            [name]="'companyVatNr'"
                            (valueChange)="complaint.authorizedRetailer.companyVatNr = $event"
                            [prefixIcon]="'info'"
                            [placeholder]="'COMPLAINT|Punkt sprzedaży - NIP' | translate"
                            [label]="'COMPLAINT|Punkt sprzedaży - NIP' | translate"
                        ></icc-input>
                        <icc-icon></icc-icon>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="currentStep === 3">
                <div class="complaint-form__step-title">
                </div>
                <ng-container *ngFor="let complaintPosition of complaintPositions; let i = index">
                    <div class="complaint-form__position-container">
                        <div class="complaint-form__position">
                            <icc-complaint-position-edit
                                [complaint]="complaint"
                                [b2cForm]="true"
                                [complaintPosition]="complaintPosition"
                                [complaintPositionAttachments]="getAttachmentsByPositionId(complaintPosition.uuid)"
                                [index]="i"
                                [positionsCount]="complaintPositions.length"
                                [isB2bComplaintForm]="isB2bComplaintForm"
                                (removeComplaintPosition)="removeComplaintPosition(i)"
                                (addAttachmentToPosition)="addAttachmentToPosition($event)"
                                (removeAttachmentToPosition)="removeAttachmentToPosition($event)"
                            ></icc-complaint-position-edit>
                        </div>
                    </div>
                </ng-container>
                <div class="complaint-form__buttons">
                    <button *ngIf="complaintPositions.length && requiredPositionsDataProvided()" type="button" iccButton appearance="outline" [prefixIcon]="'add'" (click)="addComplaintPosition()">{{ 'COMPLAINT|Dodaj usterkę - ten sam produkt' | translate}}</button>
                    <button *ngIf="complaintPositions.length && requiredPositionsDataProvided()" type="button" iccButton appearance="outline" [prefixIcon]="'add'" (click)="addComplaintPosition(true)">{{ 'COMPLAINT|Dodaj usterkę - inny produkt' | translate}}</button>
                </div>
            </ng-container>

            <ng-container *ngIf="currentStep === 4">
                <div class="complaint-form__step-title">
                </div>

                <div class="summary">
                    <div class="summary-container">
                        <div class="summary-container__element">
                            <div class="summary-container__element-title">{{ 'COMPLAINT|Zgłaszający' | translate }}</div>
                            <div class="summary-container__element-content" *ngIf="!isB2bComplaintForm">
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'PERSON|Imię i nazwisko' | translate }}</span>
                                    <span class="icc-card__content__header">{{ complaint.clientName }}</span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'CONTACT|Adres' | translate }}</span>
                                    <span class="icc-card__content__header" style="display: flex; gap: 4px;">
                                        {{complaint.installationAddress}}
                                        <span *ngIf="complaint.locationSource === 'manual'"> ({{ 'COMPLAINT|znacznik ustawiony ręcznie' | translate }})</span>
                                        <span *ngIf="complaint.locationPartialMatchConfirmed && complaint.locationSource !== 'manual'"> ({{ 'COMPLAINT|tylko częściowa zgodność adresu – pozycja znacznika potwierdzona przez Klienta' | translate }})</span>
                                    </span>
                                </div>
                                <div class="icc-card" *ngIf="complaint.locationDescription && addressMode === 'map'">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Opis lokalizacji' | translate }}</span>
                                    <span class="icc-card__content__header">{{ complaint.locationDescription }}</span>
                                </div>
                                <div class="icc-card" *ngIf="apiLoaded">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Lokalizacja na mapie' | translate }}</span>
                                    <span class="icc-card__content__header">
                                        <button
                                            iccButton
                                            (click)="openMapDialog()"
                                            appearance="primary"
                                            type="button"
                                            [disabled]="mapLoadError"
                                        >
                                        {{ 'COMPLAINT|Przejdź do mapy' | translate }}
                                        </button>
                                    </span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'CONTACT|Telefon' | translate }}</span>
                                    <span class="icc-card__content__header">{{ complaint.clientPhoneNumber }}</span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'CONTACT|Email' | translate }}</span>
                                    <span class="icc-card__content__header">{{ complaint.clientEmail }}</span>
                                </div>
                            </div>
                            <div class="summary-container__element-content" *ngIf="isB2bComplaintForm">
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'COMPANY|Nazwa firmy' | translate }}</span>
                                    <span class="icc-card__content__header">{{ activeUserType === 'authorizedRetailer' ? complaint.authorizedRetailer.companyName : complaint.distributor.companyName }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="summary-container__element">
                            <div class="summary-container__element-title">{{ 'COMPLAINT|Dane zakupu' | translate }}</div>
                            <div class="summary-container__element-content">
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Rodzaj zgłoszenia' | translate }}</span>
                                    <span class="icc-card__content__header">{{ documentTypesDict[complaint.documentTypeId] | translate }}</span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Data zakupu' | translate }}</span>
                                    <span class="icc-card__content__header">{{ complaint.purchaseDate | date: 'shortDate' }}</span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Sprzedający - nazwa' | translate }}</span>
                                    <span class="icc-card__content__header" *ngIf="!isB2bComplaintForm">{{ noSalesPoint ? complaint.authorizedRetailer?.referenceName : (complaint.assignedTo === 'distributor' ? complaint.distributor?.companyName : complaint.authorizedRetailer?.companyName) }}</span>
                                    <span class="icc-card__content__header" *ngIf="isB2bComplaintForm">{{ activeUserType === 'authorizedRetailer' ? complaint.distributor?.companyName : complaint.manufacturer?.companyName }}</span>
                                </div>
                                <div class="icc-card">
                                    <span class="icc-card__label">{{ 'COMPLAINT|Sprzedający - NIP' | translate }}</span>
                                    <span class="icc-card__content__header" *ngIf="!isB2bComplaintForm">{{ complaint.assignedTo === 'distributor' && !noSalesPoint ? complaint.distributor?.companyVatNr : complaint.authorizedRetailer?.companyVatNr }}</span>
                                    <span class="icc-card__content__header" *ngIf="isB2bComplaintForm">{{ activeUserType === 'authorizedRetailer' ? complaint.distributor?.companyVatNr : complaint.manufacturer?.companyVatNr }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="summary-positions">
                        <div class="summary-positions__title">{{ 'COMPLAINT|Dane usterek' | translate }}</div>
                        <div class="summary-positions__position" *ngIf="complaintPositions.length > 0">
                            <ng-container *ngFor="let complaintPosition of complaintPositions; index as id">
                                <div class="summary-positions__position-container">
                                    <icc-complaint-position
                                        *ngIf="complaintPosition !== null && complaint"
                                        [position]="complaintPosition"
                                        [positionTitle]="positionsTitles.get(complaintPosition.uuid)"
                                        [positionsCount]="complaintPositions.length"
                                        [document]="complaint"
                                        [attachments]="positionsAttachmentsMap.get(complaintPosition.uuid)"
                                        [id]="complaintPosition.uuid"
                                        [index]="id"
                                        [b2cForm]="true"
                                    ></icc-complaint-position>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="summary-consents" *ngIf="!isB2bComplaintForm">
                        <div class="complaint-form__subtitle">{{ 'COMPLAINT|Zgody i Klauzule informacyjne' | translate}}</div>
                        <div class="summary-consents__check-all">
                            <icc-checkbox
                                [name]="'checkAll'"
                                [ngModel]="allConsentsChecked"
                                [ngModelOptions]="{standalone: true}"
                                (change)="toggleAllConsents($event.checked)"
                            >
                                <span class="complaint-form__consent">{{ 'INTERFACE|Zaznacz wszystkie zgody' | translate }}</span>
                            </icc-checkbox>
                        </div>
                        <div class="summary-consents__consents-list">
                            <ng-container *ngFor="let consent of complaint.consents; let i = index">
                                <div class="complaint-form__checkbox">
                                    <icc-checkbox
                                        [name]="'consent' + consent.id"
                                        [ngModel]="consent.checked"
                                        [ngModelOptions]="{standalone: true}"
                                        (change)="complaint.consents[i].checked = $event.checked; allConsentsChecked = allConsentsChecked && $event.checked"
                                        [required]="consent.required"
                                    >
                                    </icc-checkbox>
                                    <span class="complaint-form__consent" [style.fontWeight]="(consent.required) ? 'bold' : 'normal'" [innerHTML]="getTrustedHtml(consent.shortDescription)"></span>
                                    <span class="complaint-form__hyperlink"><a (click)="consent.showLongDescription = !consent.showLongDescription">{{ consent.showLongDescription ? ('INTERFACE|Mniej' | translate) : ('INTERFACE|Więcej' | translate) }}</a></span>
                                </div>
                                <p *ngIf="formSubmitted && consent.required && !consent.checked" class="consent-required">{{ 'INTERFACE|Zaakceptuj, aby kontynuować' | translate }}</p>
                                <span *ngIf="consent.showLongDescription" class="complaint-form__consent" [innerHTML]="getTrustedHtml(consent.longDescription)"></span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</div>

<div class="complaint" *ngIf="showSyncedInfo">
    <h3>{{ 'COMPLAINT|Reklamacja została złożona poprawnie' | translate }}</h3>
    <p>{{ 'COMPLAINT|Dziękujemy za złożenie reklamacji. Twoja reklamacja o numerze {documentNumber} zostanie teraz przekazana do realizacji. Możesz teraz bezpiecznie zamknąć tę kartę.' | translate : { documentNumber: documentNumber } }}</p>
</div>

<div id="form-navigation" *ngIf="!showSyncedInfo">
    <button
        [disabled]="currentStep === 1 || (isB2bComplaintForm && currentStep === 2)"
        iccButton
        appearance="outline"
        (click)="previousStep()"
    >
        <icc-icon name="navigate_before"></icc-icon>
        {{ 'INTERFACE|Wstecz' | translate }}
    </button>
    <button
        *ngIf="currentStep !== 4"
        iccButton
        appearance="primary"
        (click)="nextStep()"
    >
        {{ 'INTERFACE|Dalej' | translate }}
        <icc-icon name="navigate_next"></icc-icon>
    </button>
    <button
        *ngIf="currentStep === 4"
        iccButton
        class="submit"
        type="submit"
        (click)="save()"
        [disabled]="saving"
    >
        {{ 'INTERFACE|Wyślij' | translate}}
        <icc-icon name="navigate_next"></icc-icon>
    </button>
</div>
